import { t } from "@/i18n/i18n";
import type {
  ShopCatalogItem,
  ShopCategory,
} from "@phaser/core/shop/shopTypes";
import { ARROW_SKINS } from "@phaser/core/skins/arrowSkinCatalog";

export const SHOP_CATEGORY_LABELS: Record<ShopCategory, string> = {
  ARROW_SKIN: "화살표 스킨",
  PORTAL_SKIN: "포탈 스킨",
};

export function getShopCatalog(): ShopCatalogItem[] {
  return [
    ...ARROW_SKINS.map(
      (skin): ShopCatalogItem => ({
        id: skin.id,
        textureKey: skin.textureKey,
        category: "ARROW_SKIN",

        displayName: t(`arrow.${skin.id}.name`),

        price: skin.price,
        defaultOwned: skin.defaultOwned,
        defaultEquipped: skin.defaultEquipped,
      }),
    ),
  ];
}

export interface ShopCatalogSection {
  category: ShopCategory;
  title: string;
  items: ShopCatalogItem[];
}

export function groupShopCatalogByCategory(
  catalog: ShopCatalogItem[],
  labels: Record<ShopCategory, string>,
): ShopCatalogSection[] {
  const map = new Map<ShopCategory, ShopCatalogItem[]>();

  catalog.forEach((item) => {
    const items = map.get(item.category) ?? [];
    items.push(item);
    map.set(item.category, items);
  });

  return Array.from(map.entries()).map(([category, items]) => ({
    category,
    title: labels[category],
    items,
  }));
}

export function getShopItemById(itemId: string): ShopCatalogItem | undefined {
  return getShopCatalog().find((item) => item.id === itemId);
}
